import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Dropdown from './dropdown';

import {
  fetchMe,
} from '../actions';

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch(fetchMe());
  }

  render() {
    const { user } = this.props;
    const { pathname } = this.props.location;

    let countryHandle;
    if (user && user.countryHandle) {
      countryHandle = user.countryHandle;
    }

    let pageName;
    let isStandard;
    if (pathname === '/') {
      pageName = 'Portfolio';
    }
    if (pathname === '/history') {
      pageName = 'History';
    }
    if (pathname === '/audit') {
      pageName = 'Audit';
    }
    if (pathname === '/trade') {
      pageName = 'Trade';
    }
    if (pathname === '/direct') {
      pageName = 'Vaultoro Direct';
    }
    if (pathname === '/wallets') {
      pageName = 'Wallets';
    }
    if (pathname === '/settings') {
      pageName = 'Settings';
    }
    if (pathname === '/referral') {
      pageName = 'Referral';
    }
    if (pathname === '/kyc') {
      pageName = 'Identity';
    }
    if (pathname === '/standard') {
      isStandard = true;
    }
    if (pathname === '/addressbook') {
      pageName = 'Address Book';
    }
    if (pathname === '/automation') {
      pageName = 'Automation';
    }
    if (pathname === '/fiat-trade') {
      pageName = '';
      // pageName = 'Purchase Gold with Euro';
      // if (countryHandle === 'GB') {
      //   pageName = 'Buy/Sell Assets with GBP';
      // }
    }

    return (
      <div className="top-bar">
        <div
          className={isStandard ? (
            'nav-toggle tst'
          ) : (
            'nav-toggle'
          )}
          role="button" tabIndex={0} onClick={() => this.props.toggleNav()} onKeyPress={() => this.props.toggleNav()}>
          <FontAwesomeIcon
            size="lg"
            icon={faBars}
          />
        </div>
        {isStandard ? (
          null
        ) : (
          <>
            <h4>{pageName}</h4>
            <Dropdown />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  loading: state.user.loading,
});

export default withRouter(connect(mapStateToProps)(TopBar));
